import {
  ReservationAuthorizationError, ReservationAvailabilityError,
  ReservationValidationError
} from "../../model/errors/reservation-error.model";
import {ReservationErrorCodes} from "../../model/errors/reservation-error-codes.model";
import {ReservationModelBuilder} from "../builders/reservation-model.builder";
import {ReservationErrorMessageKeys} from "../../model/errors/reservation-error-message-keys.model";
import {ApplicationError} from "../../model/errors/application-error.model";
import {User} from '../../model/user/user.model';

export class ReservationErrorAdapter {

  /*
   This is needed because the service does not return the correct errors
   */
  static adaptError(error, rateRulesData, user: User) {
    if (error instanceof ReservationAvailabilityError) {
      if (error.invalidDates && user && !user.isExplicit()) {
        const reservationTemp = new ReservationModelBuilder().withRateRulesData(rateRulesData).build();
        if (reservationTemp.rate.memberExclusive) {
          return new ReservationAuthorizationError(ReservationErrorCodes.NOT_AUTHORIZED, ReservationErrorMessageKeys.MEMBER_REQUIRED_ERROR);
        }
      }
      return error;
    }
    if (error instanceof ApplicationError) {
      return error;
    }
    return new ReservationValidationError(ReservationErrorCodes.UNKNOWN_ERROR, ReservationErrorMessageKeys.ERROR_UNKNOWN_KEY);
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/services/adapters/reservation-error.adapter.ts